module.exports = __webpack_public_path__ + "static/media/classmates.ca13ca33.svg";